// extracted by mini-css-extract-plugin
export var active = "_b6-7";
export var container = "_b6-0";
export var evenWidth = "_b6-4";
export var large = "_b6-5";
export var outlet = "_b6-8";
export var slide = "_b6-2";
export var small = "_b6-6";
export var tab = "_b6-3";
export var tabs = "_b6-1";